jQuery(document).ready(function($) {

  /*
  * jQuery throttle / debounce - v1.1 - 3/7/2010
  * http://benalman.com/projects/jquery-throttle-debounce-plugin/
  * 
  * Copyright (c) 2010 "Cowboy" Ben Alman
  * Dual licensed under the MIT and GPL licenses.
  * http://benalman.com/about/license/
  */
  function st_throttle(e,f,j,i){var c=undefined;var h,d=0;if(typeof f!=="boolean"){i=j;j=f;f=c}function g(){var o=this,m=+new Date()-d,n=arguments;function l(){d=+new Date();j.apply(o,n)}function k(){h=c}if(i&&!h){l()}h&&clearTimeout(h);if(i===c&&m>e){l()}else{if(f!==true){h=setTimeout(i?k:l,i===c?e-m:e)}}}if($.guid){g.guid=j.guid=j.guid||$.guid++}return g}

  /* DISABLE HUBSPOT TRACKING ----------------------------------- */
  // By default we block it. The GDPR plugin with allow it if consented to.
  if (typeof _hsq !== 'undefined') {
    _hsq.push(['doNotTrack', {track: true}]);
  }


  /* HEADER ON SCROLL ------------------------------------------- */
  $(window).on('scroll', st_throttle(500, function() {
    var window_scroll_top = $(window).scrollTop();
    if (window_scroll_top > 50) {
      $('body').addClass('scrolled-header');
    } else {
      $('body').removeClass('scrolled-header');
    }
  }));


  /* DELAYED LOAD HELPER ---------------------------------------- */
  function applyWhenElementExists(selector, myFunction, intervalTime) {
    var interval = setInterval(function() {
      if (jQuery(selector).length > 0) {
        myFunction();
        clearInterval(interval);
      }
    }, intervalTime);
  }


  /* BUTTONS: CONTACT ADVISOR BLOCK ----------------------------- */
  // $('.advisory-btn, .contact-advisor .contact-header .btn').each(function() {
  //   var $btn = $(this);
  //   $btn.addClass('active').wrapInner('<span class="text"></span>');
    
  //   // Temporary hack to handle custom text blocks in the Contact an Advisor sections
  //   if ($btn.hasClass('btn')) {
  //     $btn.removeClass('btn').addClass('advisory-btn');
  //   }
  // });


  /* BUTTONS: BLOCK BUILDER TEMPLATE ---------------------------- */
  $('.btn, .btn-wrap a, .wp-block-button:not(.arrow-link) .wp-block-button__link').each(function() {
    var $btn = $(this);
    $btn.addClass('active').wrapInner('<span class="text"></span>');
  });


  /* TRANSLATION BAR -------------------------------------------- */
  $('#translation-bar').each(function() {
    $('body').addClass('translation-bar');
  });


  /* SET NEGATIVE MARGINS FOR FULL WIDTH ELEMENTS --------------- */
  function setNegativeMargins($element, breakpoint, maxwidth) {
    if ($(window).innerWidth() > breakpoint) {
      var ww = $(window).innerWidth();
      var lr_margin = (ww - maxwidth) / 2;
      $element.css({
        'margin-left': '-'+lr_margin+'px',
        'margin-right': '-'+lr_margin+'px'
      });
    } else {
      $element.css({
        'margin-left': '',
        'margin-right': ''
      });
    }
  }


  /* MENU TRIGGER ----------------------------------------------- */
  $('#mm-trigger').on('click', function(e) {
    e.preventDefault();
    $('html').toggleClass('mm-open');
  });


  /* DUPLICATE PRIMARY MENU FOR MOBILE MENU --------------------- */
  $('#navigation').each(function() {
    var $mainmenu = $('#navigation').clone();
    $mainmenu.attr('id','main-menu');
    $('> ul', $mainmenu).attr('id','menu-main-menu');
    $('.mm-wrapper .col-center').prepend($mainmenu);
  });


  /* DETERMINE SITE LANGUAGE ------------------------------------ */
  /* functions.php contains a body_class filter adding a class based-on the site language */
  function determine_site_language() {

    // Create an array of all body classes that begin with wpml-lang- (should only be one!)
    var lang_class = $('body').attr('class').split(' ').filter(function(item) {
      if (item.indexOf('wpml-lang-') != -1) {
        return item;
      }
    });

    // If a class was found, return just the language portion at the end of the first item in the array
    if (lang_class.length === 1) {
      return lang_class[0].split('-').pop().toString();
    } else {
      return false;
    }

  }


  /* MAIN MENU -------------------------------------------------- */
  $('#menu-main-menu, #navigation > ul.menu').each(function() {

    // Determine site language (function above)
    var site_lang = determine_site_language();

    // Create variable for main menu
    var $mmm = $(this);

    // Iterate over each menu item
    $('li', $mmm).each(function() {

      // Create variables for this menu item
      var $menuitem = $(this);

      // Create an array of classes on this item
      var item_classes = $menuitem.attr('class').split(' ');

      // Determine if we need to open this item in a new window
      item_classes.forEach(function(e) {

        // Find a class beginning with "blank-" and the site_lang variable isn't empty
        if (e.indexOf('blank-') != -1 && site_lang) {

          // If the ending language key equals site_lang then open the link in a new window
          if (e.split('-').pop().toString() == site_lang) {
            $('> a', $menuitem).attr('target', '_blank');
          }

        }

      });

      // Handle menu items with sub-menus
      if ($menuitem.hasClass('menu-item-has-children')) {

        // Create variables for this item and its the submenu
        var $submenu = $('> ul.sub-menu', $menuitem);

        // Count the number of items in the submenu and number of items which are hidden
        var submenu_item_count = $('> li', $submenu).length;
        var submenu_items_hidden = $('> li.hide-from-menu', $submenu).length;

        // If more items are visible than hidden, add the sub-menu trigger for use in the mobile menu
        if (submenu_item_count > submenu_items_hidden) {
          $submenu.before('<button class="sub-menu-trigger" aria-label="Toggle Sub-Menu">Toggle Sub-Menu</button>');

        // Otherwise add a class to the item to hide the submenu indicator in the desktop menu
        } else {
          $menuitem.addClass('hide-submenu-indicator');
        }

      }

    });

    // If a submenu menu trigger exists, handle its functionality
    $('button.sub-menu-trigger, li.no-link > a', $mmm).each(function() {
      var $item = $(this);
      var $parent = $item.parent();
      $item.on('click', function(e) {
        e.preventDefault();
        $parent.toggleClass('show-sub-menu');
      });
    });

    // Highlight top level items when a child is being visited
    $('.current-menu-ancestor', $mmm).each(function(i, e) {

      // Create variable for top level item
      var $cma = $(this);

      // If this item contains an li.current-menu-item item which DOESN'T have the 'no-parent-highlight' class on it, highlight it
      if ($('li.current-menu-item:not(.no-parent-highlight)', $cma).length > 0) {
        $cma.addClass('highlight');
      }

    });

  });


  /* DESKTOP NAVIGATION ----------------------------------------- */
  $('#navigation').each(function() {
    var $navigation = $(this);
    $('#menu-primary-menu', $navigation).wrap('<div class="navigation-wrap"></div>');
    $navigation.prepend('<button class="navigation-trigger">Select a Stage of Ownership</button>');
    $('button.navigation-trigger', $navigation).on('click', function() {
      $navigation.toggleClass('open');
    });
    $navigation.show();
  });


  /* MEGA MENUS ------------------------------------------------- */
  $('#navigation li.mega-menu').each(function() {

    var $mm_parent = $(this);
    var $mm = $('> .sub-menu', $mm_parent);

    $mm_parent.on('mouseover', function() {

      var mm_parent_left = $mm_parent[0].getBoundingClientRect().left;
      var mm_width = $mm.innerWidth();
      var window_width = $(window).innerWidth();

      // console.log('Parent Left: '+mm_parent_left);
      // console.log('Mega Menu Width: '+mm_width);
      // console.log('Window Width: '+window_width);

      if (window_width > mm_width) {

        var margins = (window_width - mm_width)/2;
        var left_position = mm_parent_left - margins;

        $mm_parent.removeClass('full-width');
        $mm.css({
          'margin-left': '-'+left_position+'px',
          'width': ''
        });

      } else {

        $mm_parent.addClass('full-width');
        $mm.css({
          'margin-left': '-'+mm_parent_left+'px',
          'width': window_width+'px'
        });

      }

    });

  });


  /* FOOTER NAVIGATION ------------------------------------------ */
  $('nav.footer-nav').each(function() {

    var $footer_nav = $(this);
    var $menu_footer = $('#menu-footer');

    // Replace links with non-linkable spans where necessary
    $('> li.no-link', $menu_footer).each(function() {

        // Create variable to contain the text of the item
        var element_text = $('> a', this).text();

        $('> a', this).detach();
        $(this).removeClass('no-link').prepend('<span class="no-link">'+element_text+'</span>');

    });

  });


  /* COOKIEYES CONSENT BANNER PLACEMENT ------------------------- */
  applyWhenElementExists(".cky-consent-container", function(){
    
    console.log('cookie consent banner exists');
    
    $('.cky-consent-container').each(function() {

      // Setting this to false for now until I can figure-out when I can work on it
      if (false) {

        var $bar = $(this);

        function setCookieBarPosition() {

          var window_width = $(window).innerWidth();

          if (window_width <= 1800) {
            $bar.css({
              'left': '',
              'right': ''
            });
          } else {
            
            var margin = (window_width - 1600) / 2;

            $bar.css({
              'left': margin+'px',
              'right': margin+'px'
            });

          }

        }

        setCookieBarPosition();

        $(window).on('resize', st_throttle(500, function() {
            setCookieBarPosition();
          })
        );
      
      }

    });
  }, 50);


  /* TRANSLATION HEADER: GLOBAL MENU ---------------------------- */
  $('#translation-bar .marshberry-languages').each(function() {

    var $container = $(this);
    var $toggle = $('button.toggle', $container);

    $toggle.on('click', function(e) {
      e.preventDefault();
      $container.toggleClass('open');
    });

  });


  /* INDUSTRY TRANSACTIONS: QUERY VERSION ----------------------- */
  /*
  This is the current version used by the site, utilizing core WordPress pagination
  */
  $('#it-results').each(function() {

    // Add anchors to pagination links
    $('.pagination-wrapper .nav-links a', this).each(function(i,a) {
      $(a).attr('href', $(a).attr('href')+'#it-results');
    });

  });


  /* INDUSTRY TRANSACTIONS: ORIGINAL VERSION -------------------- */
  /*
  This original version queried the entire Industry Transactions database and was too memory intensive.
  We're retaining the code below for future use.
  */
  $('#industry-transactions').each(function() {

    // Set variables
    var $it = $(this);
    var $it_table_wrap = $('.table-wrap', $it);
    var $it_table = $('table#it-table', $it);
    var $it_filter = $('form#it-filter', $it);
    var $it_reset = $('input[type="reset"]', $it);
    var $it_submit = $('input[type="submit"]', $it);
    var $it_scroll_instructions = $('.table-scroll-instructions', $it);
    var $no_matches = $('.no-matches', $it);

    // Cut filter form from below the form and place it at the top
    $('.content-wrap', $it).prepend($it_filter.detach());

    // Handle the reset button
    $it_reset.on('click', function(e) {
      e.preventDefault();
      $it_table_wrap.addClass('hide');
      $it_table.addClass('hide');
      $it_scroll_instructions.addClass('hide');
      $no_matches.addClass('hide');
      $('tbody tr', $it_table).addClass('hide');

    });

    // Handle submission of form
    $it_filter.on('submit', function(e) {
      e.preventDefault();

      // Grab values from filter fields
      var transaction_count = 0;
      var transaction_buyer = $('select[name="transaction_buyer"]', $it_filter).find(':selected').val();
      var transaction_year = $('select[name="transaction_year"]', $it_filter).find(':selected').val();
      var transaction_location = $('select[name="transaction_location"]', $it_filter).find(':selected').val();
      var transaction_buyer_type = $('select[name="transaction_buyer_type"]', $it_filter).find(':selected').val();
      var transaction_seller_type = $('select[name="transaction_seller_type"]', $it_filter).find(':selected').val();
      var transaction_business_line = $('select[name="transaction_business_line"]', $it_filter).find(':selected').val();
      var transaction_deal = $('select[name="transaction_deal"]', $it_filter).find(':selected').val();

      if (transaction_buyer != '' || transaction_year != '' || transaction_location != '' || transaction_buyer_type != '' || transaction_seller_type != '' || transaction_business_line != '' || transaction_deal != '') {

        $('tbody tr', $it_table).each(function() {

          // Set visibility of row to true by default
          var show_row = true;
          var $tr = $(this);

          // Handle the Buyer Name field
          if (transaction_buyer) {
            // Try to clean-up the search term and table cell value -- There were oddities on importing from CSV
            var tb1 = transaction_buyer.replace('&amp;', '&');
            var tb2 = tb1.replace('&nbsp;', ' ');
            var td1 = $('td.transaction_buyer', $tr).html().replace('&amp;', '&');
            var td2 = td1.replace('&nbsp;', ' ');
            if ( td2 != tb2) {
              show_row = false;
            }
          }

          // Handle the Deal Year field
          if (transaction_year) {
            if ($('td.transaction_year', $tr).html() !== transaction_year) {
              show_row = false;
            }
          }

          // Handle the Location field
          if (transaction_location) {
            if ($('td.transaction_location', $tr).html() !== transaction_location) {
              show_row = false;
            }
          }

          // Handle the Buyer Type field
          if (transaction_buyer_type) {
            if ($('td.transaction_buyer_type', $tr).html() !== transaction_buyer_type) {
              show_row = false;
            }
          }

          // Handle the Realty vs Specialty field
          if (transaction_seller_type) {
            if ($('td.transaction_seller_type', $tr).html() !== transaction_seller_type) {
              show_row = false;
            }
          }

          // Handle the Seller Line of Business field
          if (transaction_business_line) {
            var tb1 = transaction_business_line.replace('&amp;', '&');
            var td1 = $('td.transaction_business_line', $tr).html().replace('&amp;', '&');
            if ( tb1 !== td1 ) {
              show_row = false;
            }
          }

          // Handle the MarshBerry Deal field
          if (transaction_deal) {
            if ($('td.transaction_deal', $tr).html() !== transaction_deal) {
              show_row = false;
            }
          }

          // Make determination of visibility of row
          if (show_row) {
            $tr.removeClass('hide');
            transaction_count++;
          } else {
            $tr.addClass('hide');
          }

        });

      }

      // Make determinatino of visibility of table
      if (transaction_count > 0) {
        $it_table_wrap.removeClass('hide');
        $it_table.removeClass('hide');
        $it_scroll_instructions.removeClass('hide');
        $no_matches.addClass('hide');
      } else {
        $it_table_wrap.addClass('hide');
        $it_table.addClass('hide');
        $it_scroll_instructions.addClass('hide');
        $no_matches.removeClass('hide');
      }

    });

    // Display the hidden filter form -- We hide it by default so you don't see the Selectize.js flash
    $it_filter.removeClass('hide');

  });


  /* INTRO CONTENT ---------------------------------------------- */
  $('.intro-content').each(function() {

    // Declare variables
    var $intro = $(this);
    var $intro_content = $('> .content', $intro);
    var $top_level_nav;
    var $title;

    // Create function to reposition the video background
    function reposition_bg($bg, $int) {

      // Declare variables
      var video_height = $bg.data('height');
      var video_width = $bg.data('width');
      var video_ratio = video_height/video_width;
      var intro_height = $int.innerHeight();
      var intro_width = $int.innerWidth();
      var intro_ratio = intro_height/intro_width;

      // If intro ratio is less than video ratio, the width is 100%
      if (intro_ratio <= video_ratio) {
        var bg_width = '100%';
        var bg_height = intro_width * video_ratio;
        $bg.css({
          'top': '50%',
          'left': '0',
          'height': bg_height+'px',
          'width': bg_width,
          'margin-top': '-'+(bg_height/2)+'px',
          'margin-left': '0'
        });
      
      // Otherwise, the height is 100%
      } else {
        var bg_width = intro_height/video_ratio;
        var bg_height = '100%';
        $bg.css({
          'top': '0',
          'left': '50%',
          'height': bg_height,
          'width': bg_width+'px',          
          'margin-top': '0',
          'margin-left': '-'+(bg_width/2)+'px'
        });

      }
      
    }

    if ($intro.hasClass('video')) {
      // Declare variable for the BG element
      var $video_bg = $('.video-bg', $intro);
      reposition_bg($video_bg, $intro_content);
      $(window).on('resize', st_throttle(500, function() {
          reposition_bg($video_bg, $intro_content);
        })
      );
    };

    // Reveal the intro section once it's all done
    $intro.addClass('show');

  });


  /* MOTION STATS FIX ------------------------------------------- */
  $('.motion-stats').each(function() {
    var $msr_1_3 = $('.msr-1 .motion-stat-3').clone();
    var $msr_2_1 = $('.msr-2 .motion-stat-4').clone();
    $('.msr-1').after('<div class="motion-stats-row msr-mobile"></div>');
    $('.msr-mobile').append($msr_1_3);
    $('.msr-mobile').append($msr_2_1);
  });


  /* OFFICE GRIDS ----------------------------------------------- */
  $('.offices-grid').each(function() {

    var $office_grid = $(this);

    function set_office_grid_item_height() {

      // Reset min-height of grid items
      $('.office .item > .wrap', $office_grid).css({
        'min-height': ''
      });

      if ($(window).width() > 600) {

        // Create variable to hold the min-height value
        var min_height = 0;

        // Cycle through each office item
        $('.office .item > .wrap', $office_grid).each(function() {

          // Set variable for curren item's height
          var this_height = $(this).innerHeight();

          // If this item's height is larger than the min_height, set the variable
          if ( this_height > min_height) {
            min_height = this_height;
          }

        });

        // Reset min-height of grid items
        $('.office .item > .wrap', $office_grid).css({
          'min-height': min_height+'px'
        });

      }

    }

    // Set height of office grid items
    set_office_grid_item_height();
    
    // Set height of office grid items on window resizing
    $(window).on('resize', st_throttle(1000, function() {
        set_office_grid_item_height();
      })
    );


  });


  /* INTRO CONTENT ---------------------------------------------- */
  $('.rich-banner-block').each(function() {

    // Declare variables
    var $banner = $(this);
    var $banner_wrap = $banner;
    var $top_level_nav;
    var $title;

    // Create function to reposition the video background
    function reposition_bg($bg, $int) {

      // Declare variables
      var video_height = $bg.data('height');
      var video_width = $bg.data('width');
      var video_ratio = video_height/video_width;
      var intro_height = $int.innerHeight();
      var intro_width = $int.innerWidth();
      var intro_ratio = intro_height/intro_width;

      // If intro ratio is less than video ratio, the width is 100%
      if (intro_ratio <= video_ratio) {
        var bg_width = '100%';
        var bg_height = intro_width * video_ratio;
        $bg.css({
          'top': '50%',
          'left': '0',
          'height': bg_height+'px',
          'width': bg_width,
          'margin-top': '-'+(bg_height/2)+'px',
          'margin-left': '0'
        });
      
      // Otherwise, the height is 100%
      } else {
        var bg_width = intro_height/video_ratio;
        var bg_height = '100%';
        $bg.css({
          'top': '0',
          'left': '50%',
          'height': bg_height,
          'width': bg_width+'px',          
          'margin-top': '0',
          'margin-left': '-'+(bg_width/2)+'px'
        });

      }
      
    }

    if ($banner.hasClass('vimeo')) {
      // Declare variable for the BG element
      var $video_bg = $('.video-bg', $banner);
      reposition_bg($video_bg, $banner_wrap);
      $(window).on('resize', st_throttle(500, function() {
          reposition_bg($video_bg, $banner_wrap);
        })
      );
    };

    // Reveal the intro section once it's all done
    $banner.addClass('show');

  });


  /* SEARCH FORM ------------------------------------------------ */
  $('.searchform').each(function() {

    // Create variables for the input field and the blinking element behind it
    var $input = $('input#s', this);
    var $blink = $('.search-blink', this);

    // On page load, if the input field isn't blank, hide the blinking element
    if ( $input.val() !== '' ) {
      $blink.addClass('hide');
    }

    // Upon focusing on the input field, if the blinking element isn't hidden, then hide it
    $input.on('focus', function() {
      if ( !$blink.hasClass('hide') ) {
        $blink.addClass('hide');
      }
    });

    // Upon clicking outside of the input field, hide the blinking element if it's not blank
    $input.on('blur', function() {
      if ( $input.val() === '' ) {
        $blink.removeClass('hide');
      } else if ( $input.val() !== '' ) {
        $blink.addClass('hide');
      }
    });

  });


  /* TEAM GRID SELECTORS ---------------------------------------- */
  $('.team-grid').each(function() {

    function set_team_grid($section) {

      // Remove active status of all sections
      $('.team-grid-header .selector button').removeClass('active');
      $('.team-grid-body-section').removeClass('active');
      $('.team-grid-footer .team-grid-footer-section').removeClass('active');

      // Add active status
      $('.team-grid-header .selector button[data-select="'+$section+'"]').addClass('active');
      $('.team-grid-body-section.'+$section).addClass('active');
      $('.team-grid-footer .team-grid-footer-section.'+$section).addClass('active');

    }

    $('.team-grid-header .selector button, .team-grid-footer button').on('click', function() {
      set_team_grid($(this).data('select'));
    });

  });


  /* DYNAMIC TEAM FILTERS --------------------------------------- */
  $('.query-filter.team-members.dynamic').each(function() {

    var $container = $(this);
    var preset_division = ($container.data('preset-division') !== undefined ? $container.data('preset-division') : '');
    var $form = $('form', $container);
    var $division_selector = $('#team_division', $form);
    var $eu_division_selector = $('#team_eu_division', $form);
    var $location_selector = $('#team_location', $form);
    var $office_selector = $('#team_office', $form);
    var $team_members = $('.team-grid-body-section a');

    function set_team_member_height($team_member) {
      $team_member.css('min-height', $('.team-member-wrap', $team_member).innerHeight()+'px');
    }

    // Set team members grid
    function set_team_members($division = '') {

      // Grab value of selected division
      if ($team_members.length > 0) {        

        // Create variable to indicate how many members are visible
        var members_count = 0;

        $.each($team_members, function(i, e) {

          $('.team-grid-body-section a').each(function() {

            // By default we want to show the member
            var show_member = true;

            // If the division selector exists...
            if ($division) {
              // If the data-divisions attribute doesn't include the selected value
              if (!$(this).data('divisions').includes($division)) {
                show_member = false;
              }
            }

            // If the eu division selector exists...
            if ($eu_division_selector.length == 1 && $eu_division_selector.val() != '') {
              // If the data-locations attribute doesn't include the selected value
              if (!$(this).data('eu-divisions').includes($eu_division_selector.val())) {
                show_member = false;
              }
            }

            // If the location selector exists...
            if ($location_selector.length == 1 && $location_selector.val() != '') {
              // If the data-locations attribute doesn't include the selected value
              if (!$(this).data('locations').includes($location_selector.val())) {
                show_member = false;
              }
            }

            // If the office selector exists...
            if ($office_selector.length == 1 && $office_selector.val() != '') {
              // If the data-locations attribute doesn't include the selected value
              if (!$(this).data('offices').includes($office_selector.val())) {
                show_member = false;
              }
            }

            // Handle how we show/hide the member
            if (show_member) {
              members_count++;
              set_team_member_height($(this));
              $(this).removeClass('hide').addClass('show');
            } else {
              $(this).addClass('hide').removeClass('show');
            }

          });

        });

        // Determine if we should show the "no results" message
        if (members_count > 0) {
          $('.our-team-no-results').removeClass('show');
        } else {
          $('.our-team-no-results').addClass('show');
        }

      }

    }

    // Handle form submissions
    $form.on('submit', function(e) {

      // Prevent default form action
      e.preventDefault();

      // Set default division value
      var set_division = '';

      // Set the division if one's been selected
      if ($division_selector.length == 1 && $division_selector.val() != '') {
        set_division = $division_selector.val();
      }

      // Set team members grid
      set_team_members(set_division);

    });

    if (preset_division != '') {
      set_team_members(preset_division);
    }


  });


  // function setNegativeMargins($element, breakpoint, maxwidth) {
  //   if ($(window).innerWidth() > breakpoint) {
  //     var ww = $(window).innerWidth();
  //     var lr_margin = (ww - maxwidth) / 2;
  //     $element.css({
  //       'margin-left': '-'+lr_margin+'px',
  //       'margin-right': '-'+lr_margin+'px'
  //     });
  //   } else {
  //     $element.css({
  //       'margin-left': '',
  //       'margin-right': ''
  //     });
  //   }
  // }

  /* BLOG ARTICLE SCRIPTS --------------------------------------- */
  $('.blog-post').each(function() {

    // Look for any callout-blocks
    $('.callout-block').each(function() {
      var $cb = $(this)
      $cb.wrap('<div class="callout-block-container"><div class="callout-block-wrap"></div></div>');
      setNegativeMargins($('.callout-block-container'), 1150, 1050);
      $(window).on('resize', st_throttle(500, function() {
          setNegativeMargins($('.callout-block-container'), 1150, 1050);
        })
      );
    });

    // Look for a table of contents
    $('.blog-toc-container').each(function() {
      var $toc = $(this);
      setNegativeMargins($toc, 1150, 1050);
      $(window).on('resize', st_throttle(500, function() {
          setNegativeMargins($toc, 1150, 1050);
        })
      );
    });

  });

  /* CONTACT AN ADVISOR SECTION --------------------------------- */
  $('.contact-advisor').each(function() {

    // Declare variables
    var $container = $(this);

    // Determine if hidden section exists
    if ($('.show-more button', $container).length > 0) {

      // Declare hidden section variables
      var $show_more = $('.show-more button', $container);
      var $hidden_section = $('.hidden-section', $container);
      var $hidden_content = $('.contact-list-wrap', $hidden_section);

      $show_more.on('click', function() {
        $show_more.addClass('hide');
        $hidden_section.css({
          'height': $hidden_content.innerHeight()+'px'
        }).addClass('visible');
      });

      $(window).on('resize', st_throttle(1000, function() {
          if ($hidden_section.hasClass('visible')) {
            $hidden_section.css({
              'height': $hidden_content.innerHeight()+'px'
            });
          }
        })
      );

    }

  });


  /* COLORBOX POP-UPS ------------------------------------------- */

  /* advanced stat pop-ups */
  $('a.adv-pop-up-link').colorbox({
    className: 'marshberry adv-colorbox',
    inline: true,
    width: '98%',
    maxWidth: 1280,
    maxHeight: '90%'
  });

  /* advisor pop-ups */
  $('a.advisor-pop-up-link').colorbox({
    className: 'marshberry advisor-colorbox',
    inline: true,
    width: '98%',
    maxWidth: 1280,
    maxHeight: '90%'
  });

  /* motion stat pop-ups */
  $('a.ms-pop-up-link').colorbox({
    className: 'marshberry ms-colorbox',
    inline: true,
    width: '98%',
    maxWidth: 1280,
    maxHeight: '90%'
  });

  $('a.launch-search').on('click', function() {
    var $search_input = $('#search-popup input#s');
    $(this).colorbox({
      className: 'marshberry search-colorbox',
      inline: true,
      width: '98%',
      maxWidth: 700,
      next: 'next'
    });
  });

  $('a.imgvid-popup').colorbox({
    inline: true,
    width: '90%',
    maxWidth: '1500px',
    onOpen: function() {
      var window_width = $(window).width();
      if ( window_width > 1650 ) {
        var iframe_height = 1500 * 0.5625; // maxWidth - 60
      } else {
        var iframe_width = window_width * .9;
        var iframe_height = iframe_width * 0.5625;
      }
      $('#vid-iframe iframe').css({
        'height': iframe_height+'px'
        // 'width': wtv_iframe_width+'px'
      });
    },
  });

  setTimeout(function() {
    $('#colorbox').each(function() {
      $('button#cboxPrevious', this).text('Previous');
      $('button#cboxNext', this).text('Next');
      $('button#cboxSlideshow', this).text('Slideshow');
    });

  }, 1000);


  /* SLICK SLIDER ----------------------------------------------- */

  $('.tec-slider').slick({
    arrows: false,
    dots: true,
    fade: true,
    slidesToScroll: 1,
    slidesToShow: 1
  });

  /* Advanced Stats Slider */
  $('.adv-stats').each(function() {

    // Create variable for parent element
    var $advs = $(this);

    $('.adv-stats-slider', $advs).not('slick-initialized').slick({
      arrows: false,
      dots: true,
      infinite: false,
      slidesToScroll: 4,
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 1500,
          settings: {
            slidesToScroll: 3,
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1100,
          settings: {
            slidesToScroll: 2,
            slidesToShow: 2
          }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 1
          }
        }
      ]
    });

  });

  // This function is tied to the stand-alone photo slick slider that follows due to the colorbox breaking upon a responsive breakpoint being hit
  function initializeSaColorbox() {
    $('.sa-photo-slider .photo a').colorbox({
      className: 'saps-colorbox',
      rel: 'saps-group',
      width: '98%',
      maxWidth: 1280,
      maxHeight: '90%'
    });
  }

  $('.sa-photo-slider .slider').each(function() {
    var $saphotoslider = $(this);

    // The following will initialize the colorbox when the slider is initialized
    $saphotoslider.on('init', function(slick) {
      initializeSaColorbox();
    });
    $saphotoslider.slick({
      arrows: false,
      dots: true,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    // The following is needed to re-initialize the colorbox functionality when the slider hits a responsive breakpoint
    }).on('breakpoint', function(event, slick, breakpoint) {
      initializeSaColorbox();
    });
  });

  /* Graphic Cards Sliders */
  $('.graphic-cards').each(function() {
    $('.content-wrap', this).slick({
      arrows: false,
      dots: false,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 3,
            dots: true
          }
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            dots: true
          }
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 1,
            dots: true
          }
        }
      ]
    });
  });

  $('.blog-listing.slider').each(function() {

    var $slider_container = $(this);
    var $slider = $('.blog-list-wrap', $slider_container);
    var slide_count = $slider.children().length;

    function resize_slides() {

      var min_height = 0;

      $('.blog-item .blog-item-content', $slider).css({
        'min-height': ''
      });

      $('.blog-item .blog-item-content', $slider).each(function() {

        if ($(this).innerHeight() > min_height) {
          min_height = $(this).outerHeight();
        }

      });

      $('.blog-item .blog-item-content', $slider).css({
        'min-height': min_height+'px'
      });

    }

    $slider.on('init reInit breakpoint', function(slick) {

      if ($slider_container.hasClass('alt')) {
        resize_slides();
      }

    });

    $(window).on('resize', st_throttle(1000, function() {
      resize_slides();
    }));

    $slick_args = {
      arrows: false,
      dots: false,
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    };

    if (slide_count === 3) {
      $slick_args.slidesToShow = 3;
    }

    if (slide_count >= 3) {
      $slick_args.responsive.push({
        breakpoint: 800,
        settings: {
          slidesToShow: 2
        }
      });
    }

    if (slide_count >= 4) {
      $slick_args.slidesToShow = 4;
      $slick_args.responsive.push({
        breakpoint: 1200,
        settings: {
          slidesToShow: 3
        }
      });
    }

    $slider.slick($slick_args);

    $('button.slide-prev', $slider_container).each(function() {
      $(this).on('click', function() {
        $slider.slick('slickPrev');
      });
    });

    $('button.slide-next', $slider_container).each(function() {
      $(this).on('click', function() {
        $slider.slick('slickNext');
      });
    });
  });

  /* Graphic Slider */

  // This function initializes the graphic slider upon initialization and with each breakpoint
  function initializeGraphicSlider($slider) {

    $('button.slide-prev', $slider).each(function() {
      $(this).on('click', function() {
        $slider.slick('slickPrev');
      });
    });

    $('button.slide-next', $slider).each(function() {
      $(this).on('click', function() {
        $slider.slick('slickNext');
      });
    });

  }
  $('.graphic-slider').each(function() {

    var $graphic_slider = $('.graphic-slider-wrap', this);

    $graphic_slider.on('init', function(slick) {
      initializeGraphicSlider($graphic_slider);
    });

    $graphic_slider.slick({
      arrows: false,
      dots: false,
      fade: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 651,
          settings: {
            arrows: false,
            dots: true
          }
        }
      ]
    }).on('breakpoint', function(event, slick, breakpoint) {
      initializeGraphicSlider($graphic_slider);
    });

  });

  /* Hubspot Sliders */
  $('.hubspot-wrap').each(function() {

    var $hubspot_slider = $('.hubspot-slider', this);

    $hubspot_slider.slick({
      arrows: false,
      dots: false,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });

    $('button.slide-prev', this).on('click', function() {
      $hubspot_slider.slick('slickPrev');
    });

    $('button.slide-next', this).on('click', function() {
      $hubspot_slider.slick('slickNext');
    });

  });

  /* Small Image Sliders */
  $('.small-image-slider').each(function() {

    var $slider = $('.slider', this);

    $slider.slick({
      arrows: true,
      dots: true,
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 5,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

  });

  /* Custom Content Slider */
  $('.custom-content-slider').each(function() {

    var $slider = $('.slider', this);

    $slider.slick({
      arrows: true,
      dots: false,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1001,
          settings: {
            arrows: false,
            dots: true,
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 700,
          settings: {
            arrows: false,
            dots: true,
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 501,
          settings: {
            arrows: false,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

  });

  /* Initialize the testimonials slider */
  /* This function determines the height of the slider and sets all slides to that height */
  function setTestimonialsHeight($slider) {

    // Set initial test height to zero
    var max_slide_height = 0;

    // Test each slide and adjust the height if the slide is taller
    $('.slick-slide', $slider).each(function() {
      if ($(this).innerHeight() > max_slide_height) {
        max_slide_height = $(this).innerHeight();
      }
    });

    // Set the min-height of all slides to the max slide height
    $('.slick-slide .testimonial-content', $slider).css({
      'min-height': max_slide_height+'px'
    });

  }

  /* Testimonials Sliders - Multi-Quote */
  $('.testimonials-slider.multi-quote').each(function() {

    var $testimonials_wrap = $(this);
    var $testimonials = $('.testimonials-wrap', $testimonials_wrap);

    // This will set the height of all slides upon initialization of slider
    $testimonials.on('init', function(slick) {
      setTestimonialsHeight($testimonials);
    });

    $testimonials.slick({
      arrows: false,
      autoplay: false,
      autoplaySpeed: 10000,
      dots: true,
      fade: false,
      infinite: false,
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 1920,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });

  });

  /* Testimonials Sliders - Photo Quotes */
  $('.testimonials-slider.photo-quotes').each(function() {

    var $testimonials_wrap = $(this);
    var $testimonials = $('.testimonials-wrap', $testimonials_wrap);

    $testimonials.slick({
      arrows: false,
      autoplay: false,
      autoplaySpeed: 10000,
      dots: true,
      fade: false,
      infinite: false,
      slidesToShow: 2,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });

  });

  /* Footer Blog Slider */
  $('.blog-slider').each(function() {

    var $container = $(this);

    // Create variable for the slider
    var $slider = $('.blog-slider-slides', $container);

    $slider.slick({
      arrows: false,
      autoplay: true,
      autoplaySpeed: 4000,
      useAutoplayToggleButton: false,
      centerMode: false,
      dots: false,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 3,
            dots: false,
            rtl: false
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            dots: false,
            rtl: false
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            dots: false,
            rtl: false
          }
        }
      ]
    })


    // Set previous and next buttons
    $('button.slide-prev', $container).on('click', function() {
      $slider.slick('slickPrev');
    });
    $('button.slide-next', $container).on('click', function() {
      $slider.slick('slickNext');
    });

  });

  /* Transactions Sliders */
  $('.transactions-slider').each(function() {

    // Define variables
    var $container = $(this);
    var $transactions = $('.transactions', $container);

    // Initialize any additional info functionality
    $transactions.on('init', function(slick) {
      initializeTransactionAddlInfo($transactions);
    });

    // Create variables to determine when to reset the slider
    var transactions_count = $('.transaction', $transactions).length;
    var transactions_visible = $('.transaction.slick-active', $transactions).length;
    var transactions_reset = false;

    $slick_args = {
      arrows: false,
      autoplay: true,
      autoplaySpeed: 4000,
      useAutoplayToggleButton: false,
      centerMode: false,
      dots: false,
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      rtl: false
    }
    if ($container.hasClass('plugin-version')) {
      $slick_args['responsive'] = [
        {
          breakpoint: 1401,
          settings: {
            slidesToShow: 4,
            dots: false,
            rtl: false
          }
        },
        {
          breakpoint: 1101,
          settings: {
            slidesToShow: 3,
            dots: false,
            rtl: false
          }
        },
        {
          breakpoint: 801,
          settings: {
            slidesToShow: 2,
            dots: false,
            rtl: false
          }
        },
        {
          breakpoint: 501,
          settings: {
            slidesToShow: 1,
            dots: false,
            rtl: false
          }
        }
      ];

    } else {
      $slick_args['responsive'] = [
        {
          breakpoint: 1920,
          settings: {
            slidesToShow: 4,
            dots: false,
            rtl: false
          }
        },
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 3,
            dots: false,
            rtl: false
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            dots: false,
            rtl: false
          }
        },
        {
          breakpoint: 550,
          settings: {
            slidesToShow: 1,
            dots: false,
            rtl: false
          }
        }
      ];
    }
    $transactions.slick($slick_args).on('breakpoint', function(event, slick, breakpoint) {
      initializeTransactionAddlInfo($transactions);
    });

    // After the slide has changed, do some calculations
    $transactions.on('afterChange', function(slick, currentSlide, nextSlide) {

      // Determine how many slides are currently visible at this breakpoint
      transactions_visible = $('.transaction.slick-active', $transactions).length;

      // Get the index of the current slide -- in this scenario it's the index of the item on the left side of the screen
      transaction_current = $transactions.slick('slickCurrentSlide');

      // If this variable has been set to true, reset the slider
      if (transactions_reset) {

        // Send the slider to the beginning
        $transactions.slick('slickGoTo', 0, false);

        // Reset the variable to false
        transactions_reset = false;
      }

      // If the length of the items is equal to the current item index + the visible items, on the next time through reset the slider
      if ( transactions_count === transaction_current + transactions_visible ) {
        transactions_reset = true;
      }

    });

    $('button.slide-prev', this).on('click', function() {
      $transactions.slick('slickPrev');
    });

    $('button.slide-next', this).on('click', function() {
      $transactions.slick('slickNext');
    });

  });


  /* TRANSACTIONS GRIDS ----------------------------------------- */
  $('.transactions-grid').each(function() {
    initializeTransactionAddlInfo($(this));
  });


  /* TRANSACTION ADDITIONAL INFO -------------------------------- */
  /* This function is used by the transactions slider and grid elements above to instantiate the additional info functionality */
  function initializeTransactionAddlInfo($element) {

    /* transaction pop-ups */
    $('a.transaction-pop-up-link', $element).colorbox({
      className: 'marshberry transaction-colorbox alt-close-button',
      inline: true,
      width: '98%',
      maxWidth: 900
    });

  }


  /* SMOOTH SCROLLING ------------------------------------------- */
  $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').not('[href*="#transaction-pop-up"]').not('[href*="#ms-pop-up"]').not('[href*="#search-popup"]').not('[href*="#advisor"]').not('[href*="#adv-pop"]').not('.no-smooth-scroll').click(function(t){if(location.pathname.replace(/^\//,"")==this.pathname.replace(/^\//,"")&&location.hostname==this.hostname){

    var e = $(this.hash);  

    // Determine the heights of possible elements on the page to take into consideration
    var top_header_height = 60; // This is the language/country selector
    var header_height = 120; // The default header height

    // Consider responsive breakpoints
    if ($(window).innerWidth() <= 500) {
      header_height = 80;
    } else if ($(window).innerWidth() <= 1600) {
      header_height = 100;
    }

    // Assemble total header height
    var total_header_height = top_header_height + header_height;

    var wpadminbar_height = ($('#wpadminbar').length > 0 ? $('#wpadminbar').innerHeight() : 0); // Height of WordPress admin bar
    var scroll_top_padding = 30; // Extra padding

    // Calculate the final offset for scrolling by removing the height of the items above (and some padding) from the total offset height
    var e_offset_top = e.offset().top - (total_header_height + wpadminbar_height + scroll_top_padding);

  (e=e.length?e:$("[name="+this.hash.slice(1)+"]")).length&&(t.preventDefault(),$("html, body").animate({
    scrollTop:e_offset_top
  },1e3,function(){var t=$(e);if(t.focus(),t.is(":focus"))return!1;t.attr("tabindex","-1"),t.focus()}))}});


  /* TOC TWEAK -------------------------------------------------- */
  $('.toc-list a').click(function(t){
    var offset_height = $('#wpadminbar').innerHeight() + $('#translate-bar').innerHeight() + $('#header').innerHeight() + 20;
    if(location.pathname.replace(/^\//,"")==this.pathname.replace(/^\//,"")&&location.hostname==this.hostname){
      var e=$(this.hash);
      var top_offset = e.offset().top - offset_height;
      (e=e.length?e:$("[name="+this.hash.slice(1)+"]")).length&&(t.preventDefault(),$("html, body").animate({scrollTop:top_offset},1e3,function(){var t=$(e);if(t.focus(),t.is(":focus"))return!1;t.attr("tabindex","-1"),t.focus()}))
    }
  });

});
